import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const PlusIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M12 3V21M3 12H21' stroke={color} strokeWidth='2.5' strokeLinecap='round' />
  </svg>
)

export default PlusIcon
